export const clamp = (value: number, min = 0, max = 1): number =>
    value < min ? min : value > max ? max : value

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t

export const seg = (t: number, a: number, b: number): number => clamp((t - a) / (b - a))

export const sstep = (t: number): number => t * t * (3 - 2 * t)

export const outQuint = (t: number): number => 1 - Math.pow(1 - t, 5)

export const inOutCubic = (t: number): number =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2

export const wrap = (value: number, n: number): number => ((value % n) + n) % n

export const REDUCED_MOTION = '(prefers-reduced-motion: reduce)'

export const prefersReducedMotion = (): boolean => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(REDUCED_MOTION).matches
}
